import { useQuery } from "@tanstack/react-query";
import { fetchParticipants, FetchParticipantsPayload } from "PFCore/services/chat/fetch_participants";
import { QueryOptions } from "PFCore/types/request_options";
import { ChatParticipant } from "PFTypes/chat_participant";

import { chatKeys } from "./query_keys";

export const useChatParticipants = (
  { conversationId, profileId, perPage, withMessage }: FetchParticipantsPayload,
  options?: QueryOptions<ChatParticipant[]>
) =>
  useQuery({
    queryKey: chatKeys.participants(conversationId || 0, profileId, perPage, withMessage),
    queryFn: () =>
      fetchParticipants({ conversationId, profileId, perPage, withMessage }).then(({ entries }) => entries),
    placeholderData: [],
    ...options
  });
